// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    url: "https://m.media-amazon.com/images/M/MV5BMzVlMmY2NTctODgwOC00NDMzLWEzMWYtM2RiYmIyNTNhMTI0XkEyXkFqcGdeQXVyNTAzNzgwNTg@._V1_QL75_UX280_CR0,0,280,414_.jpg",

    rating: "8.7",
    desc: "This is us",
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BZjBlMjIxN2ItNTMyNi00NDk5LWFhMzEtNzdiODE0Y2M4MWI2XkEyXkFqcGdeQXVyMTM1MTE1NDMx._V1_QL75_UY414_CR2,0,280,414_.jpg",

    rating: "8.9",
    desc: "Bosch:Legacy",
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BZjBlMjIxN2ItNTMyNi00NDk5LWFhMzEtNzdiODE0Y2M4MWI2XkEyXkFqcGdeQXVyMTM1MTE1NDMx._V1_QL75_UY414_CR2,0,280,414_.jpg",

    rating: "7.3",
    desc: "Outer Range",
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BMDdmMTBiNTYtMDIzNi00NGVlLWIzMDYtZTk3MTQ3NGQxZGEwXkEyXkFqcGdeQXVyMzMwOTU5MDk@._V1_QL75_UX280_CR0,0,280,414_.jpg",

    rating: "7.5",
    desc: "Night sky ",
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BZjBlMjIxN2ItNTMyNi00NDk5LWFhMzEtNzdiODE0Y2M4MWI2XkEyXkFqcGdeQXVyMTM1MTE1NDMx._V1_QL75_UY414_CR2,0,280,414_.jpg",

    rating: "7.3",
    desc: "Outer Range",
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BMDdmMTBiNTYtMDIzNi00NGVlLWIzMDYtZTk3MTQ3NGQxZGEwXkEyXkFqcGdeQXVyMzMwOTU5MDk@._V1_QL75_UX280_CR0,0,280,414_.jpg",

    rating: "8.9",
    desc: "Bosch:Legacy",
  },
];
